export default __webpack_public_path__ + "static/soehne-web-extraleicht-4c4db72ff87a68c6483a1704dd9ffcba.eot";